module.exports = __webpack_public_path__ + "img/PVCOMBANK.48bba8f4.svg";